import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from './client';

export interface SessionAccount {
  id: string;
  email: string;
}

export const ME_KEY = ['auth', 'me'] as const;

/** Prihlásený účet; `null` = neprihlásený (401), iné chyby sa propagujú. */
export function useMe() {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: async (): Promise<SessionAccount | null> => {
      try {
        return await api<SessionAccount>('/auth/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { email: string; password: string }) =>
      api<SessionAccount>('/auth/login', { method: 'POST', body: JSON.stringify(body) }),
    onSuccess: (account) => qc.setQueryData(ME_KEY, account),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api<void>('/auth/logout', { method: 'POST' }),
    onSettled: () => {
      qc.setQueryData(ME_KEY, null);
      qc.removeQueries({ predicate: (q) => q.queryKey[0] !== 'auth' });
    },
  });
}
